import React from "react";
import ShipMaintenanceTable from "./components/EmployeeLeaveTable";

function App() {
  return (
    <div>
      <ShipMaintenanceTable />
    </div>
  );
}

export default App;
